//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'App',
  created() {
    // this.wxConfig()
  },
  methods: {
    wxConfig() {
      let url = window.location.href.split('#')[0]
      let param = { url: url }
      this.$http
        .post(global.HTTP + '/common/common/wechatShare', param)
        .then(function(resp) {
          if (resp.data.code === 0) {
            let wxParam = resp.data.data
            // eslint-disable-next-line
            wx.config({
              // debug: true,
              appId: wxParam.appId,
              timestamp: wxParam.timestamp,
              nonceStr: wxParam.nonceStr,
              signature: wxParam.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'scanQRCode',
                'closeWindow',
                'hideMenuItems'
              ]
            })
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue